import React from 'react';
import PropTypes from 'prop-types';
import Button from '../CustomButtons/Button.js';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '48px', textAlign: 'center' }}>
          <h2>Algo deu errado</h2>
          <p style={{ color: '#666', marginBottom: '24px' }}>
            Ocorreu um erro inesperado na aplicação.
          </p>
          <Button color="primary" onClick={this.handleReload}>
            Recarregar página
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
